import type * as React from 'react';

import { compose, mapProps } from 'recompose';

import { FEATURE, VERB } from 'bundles/authoring/common/utils/permissions/permissionFeatures';
import type { InputCourseIdFunction } from 'bundles/teach-course-shared/utils/types';
import { withCourseFeaturePermissions } from 'bundles/teach-course/utils/withFeaturePermissions';

const withPlagiarismPermissions = (input: InputCourseIdFunction) => (Component: React.ComponentType<any>) =>
  compose(
    withCourseFeaturePermissions((props) => {
      const { courseId } = input(props);
      return {
        featurePermissions: {
          courseId,
          features: [
            {
              instanceId: courseId,
              features: [
                {
                  name: FEATURE.COURSE_GRADES,
                  verbs: [VERB.PLAGIARISM],
                },
              ],
            },
          ],
        },
      };
    }),
    // @ts-expect-error TSMIGRATION
    mapProps(({ featurePermissions, ...rest }) => ({
      canUpdatePlagiarismFlag: featurePermissions[FEATURE.COURSE_GRADES][VERB.PLAGIARISM],
      ...rest,
    }))
  )(Component);

export default withPlagiarismPermissions;
